<template>
  <el-table-column
    prop="transfer_comment"
    label="Ut. megjegyzés"
    show-overflow-tooltip
    min-width="200"
  >
    <template slot-scope="scope">
      {{ scope.row.transfer_comment }}
    </template>
  </el-table-column>
</template>
<script>
  export default {
    propName: 'transfer_comment',
  };
</script>
